/**
 * @generated SignedSource<<41cd1080c5cc4e63cd5f7a813d0d968e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BadgeKind = "emoji" | "icon" | "upload" | "%future added value";
export type LandingPageMode = "external" | "internal" | "none" | "%future added value";
export type PricingFrequency = "annually" | "monthly" | "weekly" | "%future added value";
export type PricingKind = "free" | "one_time" | "recurring" | "%future added value";
export type ProductRegistrationAvailability = "hidden" | "private" | "public" | "%future added value";
export type ProductStatus = "archived" | "draft" | "published" | "unlisted" | "%future added value";
export type UpdatePathwayInput = {
  addEntityTags?: ReadonlyArray<CreateTagUsageInput> | null;
  badge?: BadgeInput | null;
  cover?: string | null;
  coverAssetId?: string | null;
  description?: string | null;
  landingPage?: ProductLandingPageInput | null;
  membershipBenefits?: ReadonlyArray<UpdateMembershipBenefitInput> | null;
  name?: string | null;
  pathwayGroups?: ReadonlyArray<UpdatePathwayGroupInput> | null;
  pathwayId?: string | null;
  productId?: string | null;
  registrationAvailability?: ProductRegistrationAvailability | null;
  removeEntityTagIds?: ReadonlyArray<string> | null;
  richEditorCheckoutDescription?: string | null;
  slug?: string | null;
  status?: ProductStatus | null;
};
export type BadgeInput = {
  assetId?: string | null;
  color?: string | null;
  emoji?: string | null;
  icon?: string | null;
  kind: BadgeKind;
  mediaUrl?: string | null;
};
export type ProductLandingPageInput = {
  metaDescription?: string | null;
  metaImageAssetId?: string | null;
  metaImageUrl?: string | null;
  metaTitle?: string | null;
  mode?: string | null;
};
export type UpdatePathwayGroupInput = {
  id?: string | null;
  productIds: ReadonlyArray<string>;
  title: string;
};
export type UpdateMembershipBenefitInput = {
  id?: string | null;
  membershipPlanId: string;
  pricing: UpdatePricingInput;
};
export type UpdatePricingInput = {
  amountCents: number;
  frequency?: PricingFrequency | null;
  kind: PricingKind;
};
export type CreateTagUsageInput = {
  id: string;
  name?: string | null;
};
export type PathwaySettingsFormMutation$variables = {
  input: UpdatePathwayInput;
};
export type PathwaySettingsFormMutation$data = {
  readonly response: {
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
    readonly node: {
      readonly badge: {
        readonly color: string | null;
        readonly emoji: string | null;
        readonly icon: string | null;
        readonly kind: BadgeKind;
        readonly mediaUrl: string | null;
      } | null;
      readonly childPathwayGroups: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly products: {
              readonly edges: ReadonlyArray<{
                readonly node: {
                  readonly badge: {
                    readonly color: string | null;
                    readonly emoji: string | null;
                    readonly icon: string | null;
                    readonly kind: BadgeKind;
                    readonly mediaUrl: string | null;
                  } | null;
                  readonly id: string;
                  readonly name: string;
                };
              }>;
            };
            readonly title: string;
          };
        }>;
      };
      readonly cover: string;
      readonly description: string | null;
      readonly entityTagUsages: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly entityTag: {
              readonly id: string;
              readonly name: string;
            };
            readonly id: string;
          };
        }>;
      };
      readonly id: string;
      readonly includedInBenefits: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly membershipPlan: {
              readonly id: string;
            };
            readonly pricing: {
              readonly amountCents: number;
              readonly frequency: PricingFrequency | null;
              readonly kind: PricingKind;
            };
          };
        }>;
      } | null;
      readonly landingPage: {
        readonly metaDescription: string | null;
        readonly metaImageUrl: string | null;
        readonly metaTitle: string | null;
        readonly mode: LandingPageMode;
      } | null;
      readonly name: string;
      readonly organization: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"useExperienceSettingsSelectedPlans_membershipPlansFragment">;
      };
      readonly registrationAvailability: ProductRegistrationAvailability;
      readonly richEditorCheckoutDescription: string | null;
      readonly slug: string;
      readonly status: ProductStatus;
      readonly " $fragmentSpreads": FragmentRefs<"ExperienceSettingsStatusRadioGroupFragment" | "ProductBadgeStackFragment">;
    } | null;
  };
};
export type PathwaySettingsFormMutation = {
  response: PathwaySettingsFormMutation$data;
  variables: PathwaySettingsFormMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cover",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "registrationAvailability",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "richEditorCheckoutDescription",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "icon",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emoji",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mediaUrl",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "Badge",
  "kind": "LinkedField",
  "name": "badge",
  "plural": false,
  "selections": [
    (v10/*: any*/),
    (v11/*: any*/),
    (v12/*: any*/),
    (v13/*: any*/),
    (v14/*: any*/)
  ],
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mode",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "metaTitle",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "metaDescription",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "metaImageUrl",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amountCents",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "frequency",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "Product",
  "kind": "LinkedField",
  "name": "membershipPlan",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "EntityTagUsageNodeConnection",
  "kind": "LinkedField",
  "name": "entityTagUsages",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EntityTagUsageNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EntityTagUsage",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "EntityTag",
              "kind": "LinkedField",
              "name": "entityTag",
              "plural": false,
              "selections": [
                (v2/*: any*/),
                (v3/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "ValidationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "field",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "Badge",
  "kind": "LinkedField",
  "name": "badge",
  "plural": false,
  "selections": [
    (v10/*: any*/),
    (v11/*: any*/),
    (v12/*: any*/),
    (v13/*: any*/),
    (v14/*: any*/),
    (v2/*: any*/)
  ],
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v28 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 3
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PathwaySettingsFormMutation",
    "selections": [
      {
        "alias": "response",
        "args": (v1/*: any*/),
        "concreteType": "UpdatePathwayResponse",
        "kind": "LinkedField",
        "name": "updatePathway",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Product",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v15/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "LandingPage",
                "kind": "LinkedField",
                "name": "landingPage",
                "plural": false,
                "selections": [
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PathwayGroupNodeConnection",
                "kind": "LinkedField",
                "name": "childPathwayGroups",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PathwayGroupNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PathwayGroup",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v20/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProductNodeConnection",
                            "kind": "LinkedField",
                            "name": "products",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProductNodeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Product",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v2/*: any*/),
                                      (v3/*: any*/),
                                      (v15/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MembershipBenefitNodeConnection",
                "kind": "LinkedField",
                "name": "includedInBenefits",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MembershipBenefitNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MembershipBenefit",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Pricing",
                            "kind": "LinkedField",
                            "name": "pricing",
                            "plural": false,
                            "selections": [
                              (v21/*: any*/),
                              (v22/*: any*/),
                              (v10/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v23/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ExperienceSettingsStatusRadioGroupFragment"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Organization",
                "kind": "LinkedField",
                "name": "organization",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "useExperienceSettingsSelectedPlans_membershipPlansFragment"
                  }
                ],
                "storageKey": null
              },
              (v24/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ProductBadgeStackFragment"
              }
            ],
            "storageKey": null
          },
          (v25/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PathwaySettingsFormMutation",
    "selections": [
      {
        "alias": "response",
        "args": (v1/*: any*/),
        "concreteType": "UpdatePathwayResponse",
        "kind": "LinkedField",
        "name": "updatePathway",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Product",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v26/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "LandingPage",
                "kind": "LinkedField",
                "name": "landingPage",
                "plural": false,
                "selections": [
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PathwayGroupNodeConnection",
                "kind": "LinkedField",
                "name": "childPathwayGroups",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PathwayGroupNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PathwayGroup",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v20/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProductNodeConnection",
                            "kind": "LinkedField",
                            "name": "products",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProductNodeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Product",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v2/*: any*/),
                                      (v3/*: any*/),
                                      (v26/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MembershipBenefitNodeConnection",
                "kind": "LinkedField",
                "name": "includedInBenefits",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MembershipBenefitNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MembershipBenefit",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Pricing",
                            "kind": "LinkedField",
                            "name": "pricing",
                            "plural": false,
                            "selections": [
                              (v21/*: any*/),
                              (v22/*: any*/),
                              (v10/*: any*/),
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v23/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isInPublishedPathway",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Organization",
                "kind": "LinkedField",
                "name": "organization",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": "membershipPlans",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "type",
                        "value": "membership_plan"
                      }
                    ],
                    "concreteType": "ProductNodeConnection",
                    "kind": "LinkedField",
                    "name": "products",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProductNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Product",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v3/*: any*/),
                              (v6/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isFreeMembership",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MembershipBenefitNodeConnection",
                                "kind": "LinkedField",
                                "name": "membershipBenefits",
                                "plural": false,
                                "selections": [
                                  (v27/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Pricing",
                                "kind": "LinkedField",
                                "name": "pricing",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v21/*: any*/),
                                  (v22/*: any*/),
                                  (v10/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "products(type:\"membership_plan\")"
                  }
                ],
                "storageKey": null
              },
              (v24/*: any*/),
              {
                "alias": null,
                "args": (v28/*: any*/),
                "concreteType": "ProductNodeConnection",
                "kind": "LinkedField",
                "name": "childProducts",
                "plural": false,
                "selections": [
                  (v27/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProductNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Product",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Badge",
                            "kind": "LinkedField",
                            "name": "badge",
                            "plural": false,
                            "selections": [
                              (v10/*: any*/),
                              (v12/*: any*/),
                              (v11/*: any*/),
                              (v13/*: any*/),
                              (v14/*: any*/),
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__typename",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfoObjectType",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "childProducts(first:3)"
              },
              {
                "alias": null,
                "args": (v28/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "ProductBadgeStack_childProducts",
                "kind": "LinkedHandle",
                "name": "childProducts"
              }
            ],
            "storageKey": null
          },
          (v25/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ea02d14e7b6086ddf1ee83d5cdc3e955",
    "id": null,
    "metadata": {},
    "name": "PathwaySettingsFormMutation",
    "operationKind": "mutation",
    "text": "mutation PathwaySettingsFormMutation(\n  $input: UpdatePathwayInput!\n) {\n  response: updatePathway(input: $input) {\n    node {\n      id\n      name\n      slug\n      description\n      cover\n      status\n      registrationAvailability\n      richEditorCheckoutDescription\n      badge {\n        kind\n        icon\n        color\n        emoji\n        mediaUrl\n        id\n      }\n      landingPage {\n        mode\n        metaTitle\n        metaDescription\n        metaImageUrl\n        id\n      }\n      childPathwayGroups {\n        edges {\n          node {\n            id\n            title\n            products {\n              edges {\n                node {\n                  id\n                  name\n                  badge {\n                    kind\n                    icon\n                    color\n                    emoji\n                    mediaUrl\n                    id\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n      includedInBenefits {\n        edges {\n          node {\n            id\n            pricing {\n              amountCents\n              frequency\n              kind\n              id\n            }\n            membershipPlan {\n              id\n            }\n          }\n        }\n      }\n      ...ExperienceSettingsStatusRadioGroupFragment\n      organization {\n        id\n        ...useExperienceSettingsSelectedPlans_membershipPlansFragment\n      }\n      entityTagUsages {\n        edges {\n          node {\n            id\n            entityTag {\n              id\n              name\n            }\n          }\n        }\n      }\n      ...ProductBadgeStackFragment\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n\nfragment BadgeFragment on Badge {\n  kind\n  color\n  icon\n  emoji\n  mediaUrl\n}\n\nfragment ExperienceSettingsStatusRadioGroupFragment on Product {\n  type\n  status\n  isInPublishedPathway\n}\n\nfragment MembershipPlanExperiencePricingListItemFragment on Product {\n  id\n  name\n  cover\n  membershipBenefits {\n    totalCount\n  }\n  pricing {\n    id\n    amountCents\n    frequency\n    kind\n  }\n}\n\nfragment ProductBadgeStackFragment on Product {\n  childProducts(first: 3) {\n    totalCount\n    edges {\n      node {\n        id\n        badge {\n          ...BadgeFragment\n          id\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment useExperienceSettingsSelectedPlans_membershipPlansFragment on Organization {\n  id\n  membershipPlans: products(type: \"membership_plan\") {\n    edges {\n      node {\n        id\n        name\n        cover\n        isFreeMembership\n        membershipBenefits {\n          totalCount\n        }\n        pricing {\n          id\n          amountCents\n          frequency\n          kind\n        }\n        ...MembershipPlanExperiencePricingListItemFragment\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2d7444005124d0ded99f3bc9a5c85712";

export default node;
